import hello from './hello.svg'
import logo from './logo.png'
import img1 from './card images/img1.png'
import img2 from './card images/img2.png'
import img3 from './card images/img3.png'


export const images = {hello,logo,img1,img2,img3}